<template>
    <div class="person-right">
        <div class="maintop">
            <span>电子发票</span>
        </div>
        <el-divider></el-divider>
        <el-table :data="invoicelist" stripe style="width: 100%;margin-top:32px;border: 1px solid #E5E5E5;">
            <el-table-column prop="feeTypeName"
                             label="费用类型"
                             width="100"
                             align="center">
            </el-table-column>
            <el-table-column prop="contractNo"
                             label="合同编号"
                             width="170"
                             align="center">
            </el-table-column>
            <el-table-column prop="term"
                             label="费用期数"
                             width="100"
                             align="center">
            </el-table-column>
            <el-table-column prop="invoiceDate"
                             label="开票日期"
                             width="100"
                             align="center">
            </el-table-column>
            <el-table-column prop="invoicedMoney"
                             label="开票金额"
                             width="100"
                             align="right">
            </el-table-column>
            <el-table-column prop="invoiceCode"
                             label="发票代码"
                             width="130"
                             align="center">
            </el-table-column>
            <el-table-column prop="invoiceName"
                             label="发票号码"
                             width="200"
                             align="center">
            </el-table-column>
            <el-table-column label="发票下载" align="center">
                <template slot-scope="scope">
                    <img src="../../assets/imgs/down.png" v-if="scope.row.invoiceUrl" @click="down(scope.$index, scope.row)" alt="" title="点击下载电子发票" style="cursor:pointer">
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script lang="js">
    import UserApi from "@/api/user/index";
    export default {
        inject: ["reload"],
        data() {
            return {
                dialogShow: false,
                loading: false,
                invoicelist: [],
                form: {
                    rentalID: "",
                    invoiceTitleType: 0,
                    name: "",
                    companyCode: "",
                    companyName: "",
                    contractKind: 0
                }
            }
        },
        methods: {
            init: function () {
                this.dialogShow = false;
                this.loading = false;
                this.getInoviceList()
            },
            getInoviceList() {
                UserApi.getInoviceList()
                    .then(
                        (res) => {
                            this.invoicelist = res.data
                        },
                        (err) => {
                            this.$message({
                                message: err,
                                center: true,
                            });
                        }
                    )
                    .catch((error) => {
                        this.$message({
                            message: error,
                            center: true,
                        });
                    });
            },
            showDialog(index, row) {
                this.form.contractKind = row.contractKind;
                this.form.name = row.name;
                this.form.companyCode = row.companyCode;
                this.form.companyName = row.companyName;
                if (this.form.contractKind === 1) {
                    this.form.invoiceTitleType = 0;
                }
                else {
                    this.form.invoiceTitleType = 1;
                }
                this.form.rentalID = row.rentalID;
                this.dialogShow = true;
            },
            comfirmInvoice() {
                this.loading = true;
                UserApi.onInovice({ rentalId: this.form.rentalID, invoiceTitleType: this.form.invoiceTitleType })
                    .then(
                        (res) => {
                            if (res.data) {
                                this.$message({
                                    message: "开票成功！",
                                    center: true,
                                    type: "success"
                                });

                                // 刷新当前页面
                                //this.reload();
                                this.init();
                            }
                        },
                        (err) => {
                            this.$message({
                                message: err,
                                center: true,
                                type: "error"
                            });
                            this.loading = false;
                        }
                    )
                    .catch((error) => {
                        this.$message({
                            message: error,
                            center: true,
                            type: "error"
                        });
                        this.loading = false;
                    });
            },
            down(index, row) {
                if (row.invoiceUrl) {
                    window.open(row.invoiceUrl);
                }
                else {
                    UserApi.getInvoiceUrl(row.id).then(res => {
                        if (res.data) {
                            window.open(res.data);
                            window.location.href = window.location.href;
                        }
                        else {
                            this.$message({
                                message: "发票开具中，请稍候再试",
                                center: true,
                                type: "error"
                            });
                        }
                    },
                        (err) => {
                            this.$message({
                                message: err,
                                center: true,
                                type: "error"
                            });
                        }).catch((error) => {
                            this.$message({
                                message: error,
                                center: true,
                                type: "error"
                            });
                        });
                }
            },
        },
        activated() {
            this.init()
        }
    }
</script>

<style scoped>
    .el-divider {
        margin: 0;
    }

    .blue {
        color: #2C79CB;
    }

    .grey {
        color: #999999;
    }
</style>